module.exports = __webpack_public_path__ + "static/media/11n.921f53fd.svg";